import React from 'react'
import {Icon} from '@chakra-ui/react'
const GoBackIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.84323 15.4167L13.4215 21.9949L11.3001 24.1162L2.60059 15.4167L11.3001 6.71712L13.4215 8.83843L6.84323 15.4167Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.1245 35.25H26.1106C32.0016 35.25 36.7772 30.4744 36.7772 24.5833C36.7772 18.6923 32.0016 13.9167 26.1106 13.9167H4.72168V16.9167H26.1106C30.3447 16.9167 33.7772 20.3492 33.7772 24.5833C33.7772 28.8175 30.3447 32.25 26.1106 32.25H13.1245V35.25Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default GoBackIcon
